import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import SidebarFilters from './SidebarFilters';
import Sidebar from '../../components/Sidebar'; 
import './RoutingGuideLayout.scss'; // Add appropriate styles if needed

const RoutingGuideLayout = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [selectedProviderType, setSelectedProviderType] = useState(new URLSearchParams(location.search).get('providerType') || '');
  const [origin, setOrigin] = useState('');
  const [destination, setDestination] = useState('');
  const [sidebarOriginSuggestions, setOriginSuggestions] = useState([]);
  const [sidebarDestinationSuggestions, setDestinationSuggestions] = useState([]);

  useEffect(() => {
    const providerType = new URLSearchParams(location.search).get('providerType') || '';
    setSelectedProviderType(providerType);
  }, [location.search]);

  const handleProviderTypeChange = (e) => {
    const providerType = e.target.value;
    setSelectedProviderType(providerType);
    navigate(`/routing-guide?providerType=${providerType}`);
  };

  const handleSearch = () => {
    navigate(`/routing-guide/list?providerType=${selectedProviderType}&origin=${origin}&destination=${destination}`);
  };

  const handleClearFilters = () => {
    setOrigin('');
    setDestination('');
    setOriginSuggestions([]);
    setDestinationSuggestions([]);
  };

  const fetchPortSuggestions = async (value, setSuggestions) => {
    try {
      const response = await axios.get('/api/ports', { params: { query: value } });
      setSuggestions(response.data);
    } catch (error) {
      console.error('Error fetching port suggestions:', error);
    }
  };

  return (
    <div className="routing-guide-layout">
      <Sidebar>
        <SidebarFilters
          selectedProviderType={selectedProviderType}
          handleProviderTypeChange={handleProviderTypeChange}
          handleSearch={handleSearch}
          handleClearFilters={handleClearFilters}
          origin={origin}
          destination={destination}
          setOrigin={setOrigin}
          setDestination={setDestination}
          fetchPortSuggestions={fetchPortSuggestions}
          sidebarOriginSuggestions={sidebarOriginSuggestions}
          sidebarDestinationSuggestions={sidebarDestinationSuggestions}
          onSidebarOriginChange={(e, { newValue }) => setOrigin(newValue)}
          onSidebarDestinationChange={(e, { newValue }) => setDestination(newValue)}
          setOriginSuggestions={setOriginSuggestions}
          setDestinationSuggestions={setDestinationSuggestions}
        />
      </Sidebar>
      <main className="routing-guide-content">
        {children}
      </main>
    </div>
  );
};

export default RoutingGuideLayout;
